module.exports = __webpack_public_path__ + "static/media/dropdown filled icon.29948ddf.svg";